const firebaseConfig = {
  apiKey: "AIzaSyD5UvFjrQGGlhHuPgaflzKZ70qPtOY_bWc",
  authDomain: "my-travel-site-c9e7a.firebaseapp.com",
  projectId: "my-travel-site-c9e7a",
  storageBucket: "my-travel-site-c9e7a.appspot.com",
  messagingSenderId: "147996610211",
  appId: "1:147996610211:web:1ddf375da518e0f0783916"
};
export default firebaseConfig;
